









import { defineComponent, PropType, ref } from '@vue/composition-api'

import OutputConditionGroup from '@/components/organisms/h/outputCond/OutputConditionGroup.vue'
import {
  UserOutputCondition,
  outputConditionGroupOutputCondition,
  outputCondUseInfoList,
} from '@/types/entities'

export default defineComponent({
  components: {
    OutputConditionGroup,
  },
  props: {
    outputUseList: {
      type: Array as PropType<outputCondUseInfoList>,
      default: () => [],
    },
  },
  setup(_, context) {
    const changeOutputCondition = (
      params: outputConditionGroupOutputCondition
    ) => {
      const cond: UserOutputCondition = {
        delOutput: params.delOutput || [],
      }
      context.emit('change-output-condition', cond)
    }

    return { changeOutputCondition }
  },
})
